<template>
<div>
  <!-- Container-fluid starts-->
  <div class="container-fluid">
    <div class="row">
      <div class="row">
        <div class="col-md-12">
          <px-card>
            <div slot="with-padding">
              <div class="row">
                <div class="col-md-2">
                  <h5>Customers</h5>
                </div>
                <div class="col-md-4">
                  <b-input-group class="border rounded-pill p-1">
                    <div class="input-group-prepend border-0">
                      <button id="button-addon4" type="button" class="btn btn-link text-info"><i class="fa fa-search"></i></button>
                    </div>
                    <b-form-input
                        v-model="searchTitle"
                        placeholder="Type to Search"
                        aria-describedby="button-addon4"
                        class="form-control bg-none border-0"
                    ></b-form-input>
                  </b-input-group>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <VueDatePicker
                            v-model="date"
                            :min-date="minDate"
                            :max-date="maxDate"
                            placeholder="Select Date Range"
                            class="form-control"
                            range
                            fullscreen-mobile
                            validate
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <button class="btn btn-primary" @click="generateExcel()" :disabled="!date">{{disable_button ? "Please Wait..." : "Export Excel" }}</button>
                    </div>
                  </div>
                </div>

              </div>
              <div class="table-responsive datatable-vue">
                <b-table
                    striped hover
                    :items="customers.data"
                    :fields="fields"
                    :per-page="perPage"
                >
                </b-table>
              </div>

              <b-col md="6" class="mt-3 p-0">
                <b-pagination v-if="customers.data && customers.data.length >= 1"
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              @change="handlePageChange"
                              class="my-0"
                ></b-pagination>
                <div class="text-center" v-else>
                  No Records Found
                </div>
              </b-col>
            </div>
          </px-card>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {mapGetters, mapState} from "vuex";
import {getRequestParams} from '@/helpers/pagination'
import {customer_fields} from "@/pages/investor/fields/customer_field_defs";
import axios from "axios";
export default {
  components:{
    VueDatePicker
  },
  data() {
    return {
      fields: customer_fields ,
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      searchTitle: "",
      date: "",
      currentDate: new Date(),
      date_from:'',
      date_to:'',
      disable_button:false
    }
  },
mounted() {
  this.retrieveCustomers();
},
computed:{
  ...mapGetters({customers:'getInvestorCustomers'}),
  minDate () {
    return new Date(
        this.currentDate.getFullYear() - 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate()
    );
  },
  maxDate () {
    return new Date(
        this.currentDate.getFullYear() + 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate(),
    );
  },
},
  watch: {
    customers() {
      this.totalRows = this.customers.total;
    },
    searchTitle() {
      this.retrieveCustomers();
    },
    date() {
      this.date_from  = this.date.start;
      this.date_to  = this.date.end;
      this.retrieveCustomers();
    }
  },
  methods:{
    retrieveCustomers() {
      const params = getRequestParams(
          this.searchTitle,
          this.currentPage,
          this.perPage,
          this.date_from,
          this.date_to,
      );
      this.$store.dispatch('updateCustomer',params)
    },
    handlePageChange(value) {
      this.currentPage = value
      this.retrieveCustomers();
    },
    handleOnComplete(value) {
      console.log('OTP completed: ', value);
    },
    handleOnChange(value) {
      console.log('OTP changed: ', value);
    },
    generateExcel() {
      // Prepare the form data
      const formData = {
        date_from: this.date.start,
        date_to: this.date.end
      };

      // Show loading state (optional)
      this.loading = true;
      this.disable_button = true;
      // Make the request to the backend
      axios.post('investor/customers/export-report', formData, { responseType: 'blob' })
          .then((response) => {
            this.$swal({
              title:"Good job!",
              text:"Export is being processed. It will be sent to your email shortly!",
              type:'info'
            }).then(() => {
              this.loading = false;
              this.disable_button = false;
            })
          })
          .catch((error) => {
            console.error('Error generating report:', error);
            alert('An error occurred while generating the report. Please check your inputs or try again later.');
          })
          .finally(() => {
            // Reset loading state (optional)
            this.loading = false;
            this.disable_button = false;
          });
    },

  }
}
</script>

<style scoped>
.form-control:focus {
  box-shadow: none;
}

.form-control-underlined {
  border-width: 0;
  border-bottom-width: 1px;
  border-radius: 0;
  padding-left: 0;
}

</style>
